module.exports = __webpack_public_path__ + "static/img/coupon_light@2x.7bc61fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coupon_light@2x.png
// module id = M80c
// module chunks = 0